<template>
  <div style="width: 1200px; margin: 0 auto; overflow: hidden">
    <div v-html="lang == '中文' ? detail.content_cn : detail.content_en"></div>
    <el-button
      v-if="type == 'getActivityDetail'"
      @click="dialogFormVisible = true"
      type="danger"
      size="large"
      style="
        background: #ce0203;
        border: #ce0203;
        --el-button-size: 23px;
        font-size: 16px;
        margin: 20px 0;
        width: 60%;
        padding: 30px 0;
      "
      >立即报名 »</el-button
    >
  </div>
  <el-dialog v-model="dialogFormVisible" title="报名" width="500">
    <el-form :model="form">
      <el-form-item label="报名人员姓名" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off" />
      </el-form-item>
      <el-form-item label="报名人员手机" :label-width="formLabelWidth">
        <el-input v-model="form.phone" autocomplete="off" />
      </el-form-item>
      <el-form-item label="报名人员邮箱" :label-width="formLabelWidth">
        <el-input v-model="form.email" autocomplete="off" />
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="signUp"> 确认报名 </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import MyServerHttp from "../../plugins/http.js";
import Server from "../../plugins/server.js";
import apiServe from "../../plugins/api.js";
import { useRoute } from "vue-router";
import { ElMessage } from "element-plus";

//报名弹框
const dialogFormVisible = ref(false);
const formLabelWidth = "140px";
const form = reactive({
  activity_id: "",
  name: "",
  phone: "",
  email: "",
});
const signUp = async () => {
  try {
    const response = await MyServerHttp.post(apiServe.register, form);
    console.log(response.data.datas, "++++++++++++++++");
    if (response.data.datas.state == "success") {
      ElMessage.success(response.data.datas.message);
    } else {
      ElMessage.error(response.data.datas.message);
    }
  } catch (error) {
    console.error("Fetch error:", error);
    ElMessage.error(error.message);
  }
};

const router = useRoute();
const id = router.query.id;
const type = router.query.type;
form.activity_id = router.query.id;
const detail = ref({});

MyServerHttp.post(apiServe[type], {
  id: id,
})
  .then((response) => {
    detail.value = response.data.datas.detail;
  })
  .catch((error) => {
    ElMessage.error(error.datas.message);
  });
// const data = router.query.data;
// const obj = ref(null);
// obj.value = JSON.parse(data);

let lang = ref("");
if (!localStorage.getItem("lang")) {
  lang = "中文";
} else {
  lang = localStorage.getItem("lang");
}
</script>

<style scoped lang="less"></style>
